import Action from "csi/def/Action";
import { Context } from "csi/def/Context";
import declare from "dojo/_base/declare";
import { isUserInProof } from "../ProofService";

export = declare(Action, {

	constructor() {
		this.m_id = "ViewProof";
		this.modules = "Proofing";
		this.classController = "Proofing/Proof/ViewProofController";
	},

	/**
	 * @override
	 * Disable action if the user is not a member of the proof
	 */
	hasAccess(ctx: Context): boolean {
		if (!this.inherited<boolean>(arguments)) {
			return false;
		}
		const proofWorkflow = ctx.getNode();
		const proofStatus = proofWorkflow.DecisionStatus;

		if (proofStatus == "ProofDecisionStatus:Uploading" || proofStatus == "ProofDecisionStatus:Failed") {
			return false;
		}

		if (!isUserInProof(proofWorkflow)) {
			return false;
		}
		return true;
	},

	/**
	 * @override
	 * Validate if node is of ProofWorkflowInstance type and user is a member of the proof
	 */
	validate(ctx: Context): boolean {
		const node = ctx.getNode();
		return node.$Type == "ProofWorkflowInstance" && isUserInProof(node);
	},
});
